import type { NotificationUsersAndRolesProps } from '@/utils/hooks/context/toast/types';

import NewUserInvitationByManager from '@/components/composite/Notifications/UsersRoles/NewUserInvitationByManager';
// Components
import UserInvitationAccepted from '@/components/composite/Notifications/UsersRoles/UserInvitationAccepted';

const NotificationsUserRoles = ({ notification }: NotificationUsersAndRolesProps) => {
    const type = notification.type;
    switch (type) {
        case 'confirm_invitation_accepted':
            return <UserInvitationAccepted notification={notification} />;
        case 'confirm_invitation_by_manager_accepted':
            return <NewUserInvitationByManager notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsUserRoles;
